import React from 'react';
import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 60, scale: 0.95 },
  visible: { opacity: 1, y: 0, scale: 1 },
};

const MarwariHorsesSection = () => {
  return (
    <>
      {/* ✅ Desktop & Large Screens */}
      <section className="hidden lg:block bg-gradient-to-br from-gray-50 to-gray-100 px-8 py-24 overflow-hidden font-sans">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-center">
          {/* Left content */}
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: false, amount: 0.2 }}
            className="lg:col-span-5 space-y-6"
          >
            <motion.h2
              className="text-5xl font-normal text-gray-900 tracking-tight relative -top-18 left-16 mb-16"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: false }}
            >
              Legacy of <span className="text-black-600">Marwari</span>
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-gray-600">
                Horses
              </span>
            </motion.h2>

            <div className="relative group">
              <div className="absolute -inset-4 bg-gradient-to-r from-gray-300/20 to-gray-400/20 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
              <img
                src="/images/hors1.jpg"
                alt="Majestic Marwari Horse"
                className="relative rounded-2xl w-full h-[500px] object-cover shadow-2xl transition-transform duration-700 group-hover:scale-[1.02]"
              />
            </div>
          </motion.div>

          {/* Right content */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: false, amount: 0.2 }}
            className="lg:col-span-7 space-y-8"
          >
            <div className="relative group w-full ml-auto max-w-xl px-2.5 ml-14">
              <div className="absolute -inset-4 bg-gradient-to-r from-gray-400/20 to-gray-300/20 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
              <img
                src="/images/banner.jpg"
                alt="Royal Marwari Horse Heritage"
                className="relative rounded-2xl w-full h-auto object-cover shadow-xl transition-transform duration-700 group-hover:scale-[1.02]"
              />
            </div>

            <motion.div
              className="bg-white/60 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-200/20"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.1 }}
              variants={fadeUp}
              transition={{ duration: 1.2 }}
            >
              <div className="flex items-start gap-4 mb-6">
                <div className="w-2 h-16 bg-gradient-to-b from-gray-800 to-gray-600 rounded-full flex-shrink-0 mt-1"></div>
                <div>
                  <h3 className="text-xl text-gray-800 font-normal" style={{ fontSize: '32px' }}>
                    Heritage & Legacy
                  </h3>
                  <br />
                  <p className="text-gray-700 text-lg leading-relaxed" style={{ fontSize: '16px' }}>
                    Renowned for their distinctive inward-curving ears and noble lineage, 
                    Marwari horses once carried warriors and kings through battles and royal processions.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-2 h-16 bg-gradient-to-b from-gray-600 to-gray-800 rounded-full flex-shrink-0 mt-1"></div>
                <div>
                  <h3 className="text-xl text-gray-800 font-normal" style={{ fontSize: '32px' }}>
                    Living Symbols
                  </h3>
                  <br />
                  <p className="text-gray-700 text-lg leading-relaxed" style={{ fontSize: '16px' }}>
                    Symbols of valour and grace, they remain deeply tied to the region's royal heritage, 
                    offering guests a rare chance to step back in time amidst landscapes steeped in 
                    Rajasthan's storied history.
                  </p>

                </div>
              </div>

            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* ✅ Mobile & Tablet Only */}
      <section className="block lg:hidden bg-white px-4 py-16 font-sans">
        <motion.div
          className="max-w-2xl mx-auto space-y-8"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          variants={fadeUp}
          transition={{ duration: 1.2 }}
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-900">
            Legacy Of Marwari’s <span className="block text-gray-600">Horses</span>
          </h2>

          <img
            src="/images/hors1.jpg"
            alt="Majestic Marwari Horse"
            className="w-full h-64 object-cover rounded-xl shadow-md"
          />

          <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
            Renowned for their distinctive inward-curving ears and noble lineage, Marwari horses once carried warriors and kings.
            Trained with natural horsemanship, they are intelligent, calm, and deeply connected to their riders—living symbols of
            Rajasthan's royal spirit.
          </p>

          <img
            src="/images/banner.jpg"
            alt="Royal Marwari Heritage"
            className="w-full h-64 object-cover rounded-xl shadow-md"
          />
        </motion.div>
      </section>
    </>
  );
};

export default MarwariHorsesSection;
